import React from 'react'
import PropTypes from 'prop-types'
import ScoreInput from '../../inputs/score-input'

const GameInfo = ({game, register, errors, setValue}) => {
  const requiredMsg = 'Unset'

  const imageUrl = (team) => {
    return team.photo || '/images/leagues/team.png'
  }

  return <div className='game-info-section'>
    <div className='section-title'>Match Result</div>
    <div className='game-score'>
      <div className='game-score__team'>
        <span>{game.team1.name}</span>
        <img src={imageUrl(game.team1)} />
      </div>
      <div className='game-score__value'>
        <ScoreInput
          {...register('team1_score', { required: requiredMsg })}
          error={errors.team1_score}
          onChange={(e) => setValue('team1_score', e.target.value)}
        />
        <ScoreInput
          {...register('team2_score', { required: requiredMsg })}
          error={errors.team2_score}
          onChange={(e) => setValue('team2_score', e.target.value)}
        />
      </div>
      <div className='game-score__team reverse'>
        <img src={imageUrl(game.team2)} />
        <span>{game.team2.name}</span>
      </div>
    </div>
  </div>
}

GameInfo.propTypes = {
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
}

export default GameInfo
